module.exports = __webpack_public_path__ + "img/dne-exchange.43609f27.svg";